import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { ClassStudentStatsStoreModel, ClassStudentStatsUIModel } from './class-student-stats.model';
import { ClassStudentStatsState, ClassStudentStatsStore } from './class-student-stats.store';

@Injectable({ providedIn: 'root' })
export class ClassStudentStatsQuery extends QueryEntity<
  ClassStudentStatsState,
  ClassStudentStatsStoreModel,
  ClassStudentStatsUIModel,
  'id'
> {
  constructor(protected override readonly store: ClassStudentStatsStore) {
    super(store);
  }

  override readonly toUIModelFn = (entity: ClassStudentStatsStoreModel): ClassStudentStatsUIModel => ({
    ...entity,
    studentId: entity.student_id,
    classId: entity.class_id,
    projectedScorePercent: entity.projected_score_percent,
    onTimeCount: entity.on_time_count,
    lateCount: entity.late_count,
    missingCount: entity.missing_count,
    totalCount: entity.total_count,
  });
}
